/**
 * TS port of `backend/app/modules/notifications/domain/token_parser.py`.
 *
 * The regex + ordering MUST stay byte-for-byte identical to the Python
 * version — server-validated templates fail loudly here too, and the
 * email channel uses the Python parser to substitute slots while the
 * SPA uses this one. Drift between the two would show up as "renders
 * server-side but not client-side" bugs.
 */

const TOKEN_RE = /\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g;

export type Token =
  | { kind: 'text'; value: string }
  | { kind: 'var'; value: string };

export function parseTokens(text: string): Token[] {
  const out: Token[] = [];
  let pos = 0;
  TOKEN_RE.lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = TOKEN_RE.exec(text)) !== null) {
    if (match.index > pos) {
      out.push({ kind: 'text', value: text.slice(pos, match.index) });
    }
    out.push({ kind: 'var', value: match[1] as string });
    pos = match.index + match[0].length;
  }
  if (pos < text.length) {
    out.push({ kind: 'text', value: text.slice(pos) });
  }
  return out;
}

/** Substitute `{name}` placeholders, leaving unknown ones intact. */
export function safeSubstitute(
  text: string,
  vars: Record<string, string>,
): string {
  return parseTokens(text)
    .map((t) =>
      t.kind === 'text' ? t.value : (vars[t.value] ?? `{${t.value}}`),
    )
    .join('');
}
